export default __webpack_public_path__ + "static/media/Asset 11.15139b42.png";